import CandidatesIcon from 'assets/images/iPrise/Candidates.svg';
import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const RecruiterHeader: React.FC = () => {
  const navItems: NavItem[] = [
    { icon: JobQueueIcon, label: 'Job Queue', path: '/recruiter/job-queue' },
    {
      icon: CandidatesIcon,
      label: 'Candidates',
      path: '/recruiter/candidates',
    },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/recruiter/profile"
      basePath="/recruiter"
    />
  );
};

export default RecruiterHeader;
